import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem, TreeNode } from 'primeng/api';
import { LookupService } from '../../../services/lookups/lookup.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchFilter, SearchResult } from '../../../models/search.model';
import { SearchService } from '../../../services/search.service';
import { NotifierService } from 'angular-notifier';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { finalize } from 'rxjs/operators';
import { ReportFilter } from '../../../models/analytics.model';
import { Console } from 'console';


@Component({
  selector: 'app-custom-reports',
  templateUrl: './custom-reports.component.html',
  styleUrls: ['./custom-reports.component.css']
})
export class CustomReportsComponent implements OnInit {
  selectedReport:string="1";
  reportTitle :string;
  displayReportDlg :boolean;
  filterForm: FormGroup; 
  countries: SelectItem[] = [];
  posts: SelectItem[] = [];
  programAreas: SelectItem[] = [];
  divisions: SelectItem[] = [];
  reportCategories: TreeNode[];
  reportStates: SelectItem[] = [];
  reportTypes: SelectItem[] = [];
  reportDistributionTypes: SelectItem[] = [];
  reportYears:SelectItem[]=[];
  searchFilter: SearchFilter;
  selectedNodes: TreeNode[];
  searchResults: SearchResult[];
  loading: boolean;
  filters:ReportFilter;
  displayTab:boolean = false;
  index:number=0;
  currentYear: number;
  selectedItems:any;

  constructor(
    private lookupService: LookupService,
    private fb: FormBuilder,
    private searchService: SearchService,
    private notifier: NotifierService
  ) { }

  ngOnInit() {
    
    this.filterForm = this.fb.group({
      selectedCountries: [''],
      selectedPosts: [''],
      selectedProgramAreas: [''],
      selectedReportYears: [''],
      selectedReportTypes: [''],
      selectedReportDistributionTypes: [''],
      fromDate:[''],
      toDate:['']
    });
    this.LoadAdvanceFilterOptions();
  }

  LoadAdvanceFilterOptions() {

    this.LoadAllCountries();
    this.LoadAllPosts();
    this.LoadAllProgramAreas();
    this.LoadAllDivisions();
    this.LoadAllReportStates();
    this.LoadAllReportTypes();
    this.LoadAllReportDistributionTypes();
    this.LoadAllReportYears();
    this.LoadReportCategoryHierarchy();
     
  }
  
  

  onRunReport()
  {
      this.filters = new ReportFilter();
        if(this.selectedReport == "1")
        {
          if(!this.filterForm.controls["fromDate"].value  && this.filterForm.controls["toDate"].value)
          {
            this.notifier.notify('error', 'Please select From Date');
            return;
          }
          
          if(this.filterForm.controls["fromDate"].value  && !this.filterForm.controls["toDate"].value)
          {
            this.notifier.notify('error', 'Please select To Date');
            return;
          }
          this.filters.fromDate = this.filterForm.controls["fromDate"].value;
          this.filters.toDate = this.filterForm.controls["toDate"].value;
        }      
      if (this.selectedNodes !== undefined) 
      this.TraverseChildNodes(this.selectedNodes, this.filters.selectedReportCategories);   
      this.filters.selectedCountries = this.filterForm.controls["selectedCountries"].value;
      this.filters.selectedPosts = this.filterForm.controls["selectedPosts"].value;
      this.filters.selectedProgramAreas =this.filterForm.controls["selectedProgramAreas"].value;
      this.filters.selectedReportYears = this.filterForm.controls["selectedReportYears"].value;
      this.filters.selectedReportDistributionTypes = this.filterForm.controls["selectedReportDistributionTypes"].value;
      this.filters.selectedReportTypes = this.filterForm.controls["selectedReportTypes"].value;
      console.log(JSON.stringify(this.filters));      
      this.RunSelectedReport();

  }
  private TraverseChildNodes(element: TreeNode[], selectedReportCategories: number[]) {
    element.forEach(child => {
      if (child.children.length == 0) {
        if (selectedReportCategories.indexOf(child.data) == -1) selectedReportCategories.push(child.data);
      } else {
        this.TraverseChildNodes(child.children, selectedReportCategories);
      }
    });
  }
  onReset()
  {    
    this.selectedNodes = [];
    this.searchResults = new Array<SearchResult>();
    this.reportYears=[];
    this.LoadAllReportYears();
   // this.selectedItems=this.reportYears.filter(x=>x.label==new Date().getFullYear().toString())[0].value;
   // this.filterForm.patchValue({selectedReportYears:this.reportYears.filter(x=>x.label==new Date().getFullYear().toString())[0].value});
  
  }
  defaulyYear()
  {
    this.currentYear = new Date().getFullYear();
    this.filters = new ReportFilter();
    for (let cnt = this.reportYears.length - 1; cnt >= 0; cnt--) {
           
        if (this.reportYears[cnt].label == this.currentYear.toString()) {
        this.selectedItems=[this.reportYears[cnt].value];
        }
         }
  }

  onDisplayTab():void
  {
    this.displayTab=false
  }
  handleChange(e) {
    this.index = e.index;

  }
  private RunSelectedReport()
  {
    this.displayTab =true;
    this.index = 1;
    if(this.selectedReport == "1")
    {
         this.reportTitle="Report Download Counts";
    }
    if(this.selectedReport == "2")
    {
         this.reportTitle="Variance of Reports based on due dates";
    }
    if(this.selectedReport == "3")
    {
         this.reportTitle="Report Counts Submitted by Post";
    }
    

    
  }
 

 private LoadAllPosts() {
   
    this.lookupService.getAllPosts$().subscribe(postList => {
      //this.posts.push({ label: 'All Posts', value: '' });
      postList.forEach(val => {
        if (
          this.posts
            .map(function(v) {
              return v.value;
            })
            .indexOf(val.locationName.toString()) == -1
        )
          this.posts.push({ label: val.locationName.toString(), value: val.locationName.toString() });
      });

      this.posts.sort((a, b) => {
        if (a.label === b.label) return 0;
        //if (a.label == 'All Posts') return -1;
        //if (b.label == 'All Posts') return 1;

        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
    });
  }

  private LoadAllCountries() {
    this.lookupService.getAllCountries$().subscribe(countryList => {
      
      countryList.forEach(val => {
        this.countries.push({ label: val.locationName.toString(), value: val.id });
      });
    });
  }



  private LoadAllProgramAreas() {
    this.lookupService.getAllProgramAreas$().subscribe(programAreaList => {
      //this.programAreas.push({ label: 'All Program Areas', value: '' ,styleClass:'ui-state-highlight'});
      programAreaList.forEach(val => {
        this.programAreas.push({ label: val.locationName.toString(), value: val.id });
      });
    });
  }


  private LoadAllDivisions() {
    this.lookupService.getAllDivisions$().subscribe(divisionList => {
      //this.divisions.push({ label: 'All Divisions', value: '' ,styleClass:'ui-state-highlight'});
      divisionList.forEach(val => {
        this.divisions.push({ label: val.locationName.toString(), value: val.id });
      });
    });
  }


  private LoadAllReportTypes() {
    this.lookupService.getAllReportTypes$().subscribe(reportTypeList => {
      //this.reportTypes.push({ label: 'All Report Types', value: '-1' ,styleClass:'ui-state-highlight'});
      reportTypeList.forEach(val => {
        this.reportTypes.push({ label: val.description.toString(), value: val.id });
      });
    });
  }

  private LoadAllReportDistributionTypes() {
    this.lookupService.getAllReportDistributionTypes$().subscribe(reportDistributionTypeList => {
      //this.reportDistributionTypes.push({ label: 'All Report Distribution Types', value: '-1' ,styleClass:'ui-state-highlight'});
      reportDistributionTypeList.forEach(val => {
        this.reportDistributionTypes.push({ label: val.description.toString(), value: val.id });
      });
    });
  }


  private LoadAllReportStates() {
    this.lookupService.getReportStates$().subscribe(reportStateList => {
      //this.reportStates.push({ label: 'All Statuses', value: '' ,styleClass:'ui-state-highlight'});
      reportStateList.forEach(val => {
        this.reportStates.push({ label: val.stateName.toString(), value: val.id });
      });
    });
  }

  private LoadAllReportYears()
  {
          
        
        this.currentYear = new Date().getFullYear();
        this.lookupService.getReportYear().subscribe(reportYearList=>{
        
        reportYearList.sort((a, b) => {
          
          if (a.year < b.year) return 1;
          if (a.year > b.year) return -1;
          return 0;
        });

        reportYearList.forEach(val => {
          this.reportYears.push({ label: val.year.toString(), value: val.id });
         
        });
         for (let cnt = reportYearList.length - 1; cnt >= 0; cnt--) {
           
        if (reportYearList[cnt].year == this.currentYear ) {
        this.selectedItems=[reportYearList[cnt].id];
        }
         }
      });
     
  }
 
  private LoadReportCategoryHierarchy() {

      this.loading = true;

      this.lookupService
      .getReportCategoryHierarchy$()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(data => {
      //console.log(Array.of(data));

      this.reportCategories = Array.of(data);
      this.reportCategories[0].expanded = true;
      this.reportCategories[0].children.sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
    });

    
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/reports-dashboard/custom-reports/custom-reports.component.ts